<style lang="scss" scoped>

.myAmpleon .main .container {
    width: auto;
}

.myAmpleon .content {
    @media screen and (max-width: 767px) {
        margin-top: 0;
    }
}

h3.page-title {
    color: #000 !important;
    font-size: 24px;
    line-height: 29px;
}

.sidebar, .banner {
    display: none;
}

.content {
    left: 0;
    width: 100% !important;
}

.account-blocked-wrapper-row {
    min-height: 100vh;

    @media (max-width: 991px) {
        flex-direction: column-reverse;
        min-height: auto;
    }

    .parametric-intro {
        margin: 0;
    }

    .page-title {

        @media (max-width: 767px) {
            padding: 15px 0 !important;
        }
    }

    .image-section {

        @media (max-width: 991px) {
            height: 270px;
        }

        @media (max-width: 767px) {
            height: 402px;
        }
    }
}

.top-bar {
    background-color: #003b71;
    height: 60px;
    width: 100%;
    top: 50px;
    left: 0;
    z-index: 2;
    overflow: hidden;
}

.row--flex {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
}

.image-section {
    display: flex;
    flex-direction: column;
    font-family: "Open Sans", sans-serif;
    position: relative;
    height: 100vh;
    background-image: url("../assets/images/register-img.jpg");
    background-position: center;
    -webkit-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
}

.overlay {
    opacity: 0.8;
    color: #fff;
    background: #003B71;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
}

.svg-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 170px;

    path {
        fill: #ffffff;
    }
}

.col-spacing-75 {
    padding: 0 75px;

    @media (max-width: 991px) {
        padding: 0 25px;
    }

    @media (max-width: 767px) {
        padding: 0 15px;
    }
}

.form-check-label {
    margin: 0 0 0 20px;
    font-size: 12px;
    font-weight: 300;
    line-height: 13px;
    transform: translateY(-2px);
}

.form-textarea {
    width: 100%;
}

.account-blocked-intro {
    margin: 0;
    padding-top: 43px !important;
}

.account-blocked-info {
    margin-bottom: 48px;
}

.account-blocked-info__paragraph {
    font-size: 15px;
    font-weight: bold;
    line-height: 20px;
}

.form-control {
    padding: 5px 18px;
    border-color: #ddd;
    box-shadow: none;
    font-size: 14px;
    line-height: 20px;

    &::-webkit-input-placeholder { /* Edge */
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }

    &::placeholder {
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }
}
</style>

<template>
    <div class="account-blocked-wrapper">
        <div class="top-bar"></div>

        <div class="row row--flex account-blocked-wrapper-row">
            <div class="col-md-6 col-spacing-75">
                <div class="account-blocked-intro">
                    <h3 class="page-title">Account blocked. Too many failed login attempts</h3>
                </div>

                <div class="account-blocked-info">
                    <p class="account-blocked-info__paragraph">Please enter your email address below.</p>
                    <p class="account-blocked-info__paragraph">You will then receive an email with a link to reset your
                        password and re-activate your account.</p>
                    <p class="account-blocked-info__paragraph">Please follow the steps provided in the email.</p>
                    <p class="account-blocked-info__paragraph">If you do not receive an email from us shortly, it might
                        be due to the fact that you mistyped your email address or our mail has ended up in your spam
                        folder.</p>
                </div>

                <div>
                    <form @submit.prevent="handleSubmit" autocomplete="off" novalidate>
                        <div class="row form-row">
                            <div class="form-group col-md-12">
                                <input type="text" v-model="user.email" class="form-control" id="inputEmail"
                                       placeholder="Email *"
                                       :class="{ 'is-invalid': formErrors && $v.user.email.$error }">
                                <div v-if="formErrors && $v.user.email" class="invalid-feedback">
                                    <p v-if="formErrors && !$v.user.email.required">E-mail address is required.</p>
                                    <p v-else-if="!$v.user.email.email">Please enter a valid e-mail address.</p>
                                </div>
                            </div>
                        </div>

                        <ReCaptchaTerms></ReCaptchaTerms>

                        <div class="row form-row">
                            <div class="form-group col-md-12">
                                <button type="submit" class="btn btn-primary submit-button">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import ReCaptchaTerms from "../components/ReCaptchaTerms";
import {FINALIZE_ACTION, FORGOT_PASSWORD} from "@/store/actions.type";
import {mapAsyncGetters, STATUS} from "@/store/utils/async";

export default {
    name: "accountLocked",
    components: {
        ReCaptchaTerms
    },
    data() {
        return {
            user: {
                email: "",
                token: ""
            },
            formErrors: false
        };
    },
    validations: {
        user: {
            email: {required, email},
        }
    },
    computed: {
        ...mapAsyncGetters(FORGOT_PASSWORD)
    },
    watch: {
        status: function (newValue) {
            if (this.isFinished) {
                if (newValue === STATUS.SUCCESS) {
                    this.$router.push({ name: "password-reset-confirm", params: {email: this.user.email }});
                }
            }
        }
    },
    methods: {
        async handleSubmit(e) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.formErrors = true;
            } else {
                this.user.token = await this.$recaptcha('lockedAccount');
                await this.$store.dispatch(FORGOT_PASSWORD, this.user)
                    .then(() => this.$store.dispatch(FINALIZE_ACTION, FORGOT_PASSWORD));
            }
        }
    }
};
</script>